import React from 'react';

import { translations } from '../../locale/translations';

import { Container, Hint, HintContainer, Pointer, PointerBorder, PointerWrapper } from './PasswordHint.styles';

type Props = {
    hints: Array<[boolean, string]>;
    lang: string;
};

export const PasswordHint = ({ hints, lang }: Props) => {
    const locale = translations[lang];

    return (
        <Container>
            <PointerWrapper>
                <PointerBorder>
                    <Pointer />
                </PointerBorder>
            </PointerWrapper>
            <HintContainer>
                <div>{locale.passHint}</div>
                {hints.map(([valid, name], index) => {
                    return (
                        <Hint key={index} valid={valid}>
                            {name}
                        </Hint>
                    );
                })}
            </HintContainer>
        </Container>
    );
};
